import React, { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext();
export const useCraftsCart = () => useContext(Ctx);
const KEY = "nba_crafts_cart";
const norm = (v) => v || null;

export const CraftsCartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch {}
  }, [items]);

  const add = (c, tier) => {
    const tier_id = norm(tier?.id);
    const price = tier ? tier.price : c.price;
    const title = tier ? `${c.title} — ${tier.name}` : c.title;
    setItems((prev) => prev.some((x) => x.craft_id === c.id && norm(x.tier_id) === tier_id)
      ? prev
      : [...prev, { craft_id: c.id, tier_id, slug: c.slug, title, price, cover_image: c.cover_image, physical: !!tier?.physical }]);
    setOpen(true);
  };
  const remove = (craft_id, tier_id = null) =>
    setItems((p) => p.filter((x) => !(x.craft_id === craft_id && norm(x.tier_id) === norm(tier_id))));
  const clear = () => setItems([]);
  const has = (id, tier_id = null) => items.some((x) => x.craft_id === id && norm(x.tier_id) === norm(tier_id));
  const total = items.reduce((s, x) => s + Number(x.price || 0), 0);

  return (
    <Ctx.Provider value={{ items, add, remove, clear, has, total, count: items.length, open, setOpen }}>
      {children}
    </Ctx.Provider>
  );
};
